module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_fm1_r1"
    }
  }, [_vm._v("Jossey-Bass Teacher")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_ata_r1"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_fm2_r1"
    }
  }, [_vm._v("About This Book")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_fm3_r1"
    }
  }, [_vm._v("Alignment to National Council of Teachers of Mathematics Standards")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_fm4_r1"
    }
  }, [_vm._v("How to Use This Resource")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_p01_r1"
    }
  }, [_vm._v("Part One - Implementing Projects in the Math Class")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c01_r1"
    }
  }, [_vm._v("Chapter One - Overview of projects in the math class")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c01_r1#h1"
    }
  }, [_vm._v("Your Role")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c01_r1#h2"
    }
  }, [_vm._v("Supporting the Standards of the National Council of Teachers of Mathematics")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c01_r1#h3"
    }
  }, [_vm._v("Strategies for Problem Solving")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c01_r1#h4"
    }
  }, [_vm._v("Creating Your Own Projects")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c01_r1#h5"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1"
    }
  }, [_vm._v("Chapter Two - Managing projects in your math class")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h1"
    }
  }, [_vm._v("Structuring Your Class")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h2"
    }
  }, [_vm._v("Creating and Maintaining a Positive Environment")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h3"
    }
  }, [_vm._v("Teaching Suggestions")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h4"
    }
  }, [_vm._v("Individual and Team Conferences")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h5"
    }
  }, [_vm._v("The Value of Cooperative Problem Solving")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h6"
    }
  }, [_vm._v("Organizing Teams")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h7"
    }
  }, [_vm._v("The Importance of Sharing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h8"
    }
  }, [_vm._v("Writing in Math Class")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h9"
    }
  }, [_vm._v("Using Technology with Math Projects")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h10"
    }
  }, [_vm._v("Technology Training")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h11"
    }
  }, [_vm._v("Math Projects and the Internet")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c02_r1#h12"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three - Assessing math projects")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observation Logs")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c03_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Checklists")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c03_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Point Systems for Project Assessment")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c03_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evaluating Writing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c03_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Assessment")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c03_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two - The Projects")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section One - Math and Science")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 1  - The benefits of recycling")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 2  - Endangered species: Can they be saved?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 3  - Charting your calories")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 4  - How many calories do you burn each day?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 5  - It is only natural")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 6  - Designing a flower bed")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 7  - Buying a class aquarium")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 8  - The school’s new lunch program")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 9  - What is the weather?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c04_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 10  - A flight to Mars")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section Two - Math and Social Studies")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 11  - A great mathematician")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 12  - An election poll")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 13  - Landmarks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 14  - Creating a scale map")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 15  - A game: What date is that?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 16  - An interview to math’s past")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 17  - Rating consumer products")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 18  - Lands of ethnic origin: A statistical potpourri")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 19  - A land of immigrants")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 20  - The games people play")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c05_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 21  - Back to the past")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section Three - Math and Language")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 22  - Becoming the experts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 23  - Great debates")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 24  - The mathematics publishing company")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 25  - Rating math Web sites")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 26  - Fictional numbers: Writing a story")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 27  - A mathematical autobiography")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 28  - Puzzling")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 29  - Lending a math hand")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 30  - Sharing the math word")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 31  - Keeping a math journal")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c06_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 32  - Math portfolios")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section Four - Math and Art and Music")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 33  - Making a math poster")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 34  - Creating a logo")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 35  - I wanna be like Escher")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 36  - The Plus and Minus comic strip")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 37  - Numbers and songs")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 38  - The math in music")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 39  - Making three-dimensional octahedra and classroom decorations")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 40  - Creating a greeting card for Math Awareness Month")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 41  - The geometry and art of architecture")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c07_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 42  - Designing a quilt pattern")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section Five - Math and Sports and Recreation")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 43  - Choosing a membership plan at a health club")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 44  - Equipment for the school’s workout room")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 45  - Comparing sports superstars")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 46  - Math and the big game")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 47  - Your unique exercise program")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 48  - The big dance")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 49  - The numbers game")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 50  - Planning a sundae party")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c08_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 51  - Going on vacation")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section Six - Math and Life Skills")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 52  - Making a budget")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 53  - A floor plan of my room")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 54  - The costs of pets")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 55  - Maintaining a math class Web site")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 56  - Selecting a sound system using the Internet")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 57  - Buying a car")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 58  - What is on the test?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 59  - Checks and balances")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_c09_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project 60  - Math in my life: An assessment")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/musc_9781118040942_oeb_eula_r1#eula",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("End User License Agreement")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fff716d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/musc_9781118040942_oeb_toc_r1.vue
// module id = 57
// module chunks = 0